
import { Vue, Component, Prop } from "vue-property-decorator";
import {getSrc} from "@/utils/misc";
@Component({})
export default class UserListAvatar extends Vue {
  @Prop({ default: null })
  public users: any;

  private getSrc: (string) => string = getSrc;
}
